/** @file App.js
  * @brief Registers the app into the html page
  *
  * @author Justin Eslinger - Fivestone Studios
  * @date 07/23/2020
  *
  */
import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { AppContext } from './AppContext';
import { AutoTrack } from './Analytics';

import Home from './jsx/index';
import Step1 from './jsx/step1';
import Step1IMG from './jsx/step1_img';
import Step2 from './jsx/step2';
import Step2IOS from './jsx/step2_ios';
import Step2IMG from './jsx/step2_img';
import Step3 from './jsx/step3';
import Step3IMG from './jsx/step3_img';
import Finished from './jsx/finished';
import Processed1 from './jsx/processed1';
import Processed2 from './jsx/processed2';

import { s3Config } from './Config';

export default class App extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      phone: "",
      message: "",
      image: null,
      video: null
    }
  }

  componentDidMount() {

    AutoTrack();

    document.onkeyup = e => {
      if (e.target.value) {
        e.target.classList.add("inputed");
      }
      else {
        e.target.classList.remove("inputed");
      } 
    }

    console.log("Config: ", s3Config);
  }  
  
  render() {
    return (
      <AppContext.Provider value={this.state}>
        <Router>
          <Route exact={true} path="/" component={Home}/>
          <Route exact={true} path="/step1" component={Step1}/>
          <Route exact={true} path="/step1img" component={Step1IMG}/>
          <Route exact={true} path="/step2" component={Step2}/>
          <Route exact={true} path="/step2ios" component={Step2IOS}/>
          <Route exact={true} path="/step2img" component={Step2IMG}/>
          <Route exact={true} path="/step3" component={Step3}/>
          <Route exact={true} path="/step3img" component={Step3IMG}/>
          <Route exact={true} path="/finished" component={Finished}/>
          <Route exact={true} path="/share/:uuid/:userName" component={Processed1}/>
          <Route exact={true} path="/view/:uuid/:userName" component={Processed2}/>
        </Router>
      </AppContext.Provider>
    );
  }
}